export default "__VITE_ASSET__D$fDZSr7__"